import "./ReoCarousel.css.ts.vanilla.mjs";
var o = "p273__ReoCarousel-2b94_fc747109d__fal5jr0";
export {
  o as reoCarousel
};
//# sourceMappingURL=ReoCarousel.mjs.map
